import { Checkbox, Row } from '@rematter/ui-web';

const DAY_KEYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;

type DaysOfWeekPickerProps = {
  value: Record<string, boolean> | null | undefined;
  onChange: (days: Record<string, boolean>) => void;
  dayLabels: Record<string, string>;
};

export const DaysOfWeekPicker = ({
  value,
  onChange,
  dayLabels,
}: DaysOfWeekPickerProps) => {
  const handleChange = (key: string, checked: boolean) => {
    const current: Record<string, boolean> = {};
    for (const day of DAY_KEYS) {
      current[day] = value?.[day] ?? false;
    }
    onChange({ ...current, [key]: checked });
  };

  return (
    <Row className="@DaysOfWeekPicker flex-wrap gap-2">
      {DAY_KEYS.map((day) => (
        <Checkbox
          key={day}
          isSelected={value?.[day] ?? false}
          onChange={(checked) => handleChange(day, checked)}
        >
          {dayLabels[day] ?? day}
        </Checkbox>
      ))}
    </Row>
  );
};
